// Default Dailies calculator inputs. Shared by CalculatorContext (initial
// state) and utils/dailiesShare (share-link encoding), and kept free of heavy
// imports so the context doesn't pull the camera database into the main bundle.
export const DAILIES_DEFAULTS = {
  brand: 'ARRI',
  camera: 'ALEXA  35',
  resolution: '4.6K 3:2 Open Gate (4608 x 3164)',
  codec: 'ARRIRAW',
  framerate: '24',
  footagePerDay: '04:00:00:00',
  shootDays: 1,
  dailiesCodec: 'Apple ProRes LT',
  selectedRatio: 'Match',
  width: 1920,
  height: 1080,
};
